cpvars = require("../cpvars")

$(->
  $(document).on 'reload', '.lazy', ->
    mobile = if $(window).width() < cpvars.mobilePivot
      1
    else
      0
    if $(this).data('params')?
      params = $.extend $(this).data('params'), { mobile: mobile }
      $(this).load $(this).data('load'), params, ->
        $(this).trigger('dom_updated')
    else
      url = $(this).data('load')
      mparam = "mobile=#{mobile}"
      sep = if url.indexOf('?') > -1
        "&"
      else
        "?"
      $(this).load "#{url}#{sep}#{mparam}", ->
        $(this).trigger('dom_updated')

  $('.lazy:not(.delayed)').each ->
    $(this).trigger('reload')

  $('.collapse.lazy.delayed').on 'show.bs.collapse', ->
    $(this).trigger('reload')
)
